"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMatch = void 0;
exports.isMatch = (value, pattern) => new RegExp(pattern).test(value);
//# sourceMappingURL=is-match.js.map